import { sameDay } from "./clientAppUtils";

export function sessionTimeKey(iso) {
  if (!iso) return null;
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return null;
  return d.toISOString();
}

export function sortSessionsByStart(sessions) {
  return [...(sessions || [])].sort(
    (a, b) => new Date(a.start_datetime) - new Date(b.start_datetime),
  );
}

export function pickNearestUpcoming(sessions, now = new Date()) {
  return (
    sortSessionsByStart(sessions).find(
      (s) => s.status !== "cancelled" && new Date(s.start_datetime) >= now,
    ) || null
  );
}

export function pickUpcomingSessions(sessions, limit = 3, now = new Date()) {
  return sortSessionsByStart(sessions)
    .filter(
      (s) => s.status !== "cancelled" && new Date(s.start_datetime) >= now,
    )
    .slice(0, limit);
}

export function isCompetitionSession(session) {
  return (
    session?.session_kind === "event" && session?.event_kind === "competition"
  );
}

export function isClubEventSession(session) {
  return session?.session_kind === "event";
}

export function pickNearestTrainingSession(sessions, now = new Date()) {
  return (
    sortSessionsByStart(sessions).find(
      (s) =>
        s.status !== "cancelled" &&
        new Date(s.start_datetime) >= now &&
        !isCompetitionSession(s),
    ) || null
  );
}

export function sessionsOnDay(sessions, day) {
  return sortSessionsByStart(sessions).filter(
    (s) => s.status !== "cancelled" && sameDay(s.start_datetime, day),
  );
}

export function sessionKindsOnDay(sessions, day) {
  const daySessions = sessionsOnDay(sessions, day);
  let training = 0;
  let competition = 0;
  for (const session of daySessions) {
    if (isClubEventSession(session)) competition += 1;
    else training += 1;
  }
  return { training, competition, total: daySessions.length };
}

export function membershipHeadlineChips(membership, stats) {
  if (!membership) return [];

  const chips = [];
  const planName = membership.plan?.name?.trim();
  const visits = membership.visits_remaining;
  const visitsLabel =
    visits != null ? `${visits} ${visits === 1 ? "занятие" : "занятий"}` : null;

  if (planName) {
    chips.push({ key: "plan", label: planName });
  }

  if (visitsLabel) {
    const planLooksLikeVisits =
      planName &&
      (planName === visitsLabel ||
        (/\d+/.test(planName) && /занят/i.test(planName)));
    if (!planLooksLikeVisits) {
      chips.push({ key: "visits", label: visitsLabel });
    }
  }

  if (stats?.attendance_pct != null) {
    chips.push({
      key: "attendance",
      label: `${stats.attendance_pct}% явка`,
      accent: true,
    });
  }

  return chips;
}
